import React, { lazy } from 'react';
import { RoutesNames } from 'affiny-desktop/src/routes/routes-names';

const LoginDebugComponent = (lazy(
  () => import('../pages/desktop/LoginDebug')
) as unknown) as React.LazyExoticComponent<() => JSX.Element>;
const HomeComponent = lazy(() => import('../pages/desktop/Home'));
const ProfileDisplayComponent = lazy(
  () => import('../pages/desktop/ProfileDisplay')
);
const NotFoundComponent = lazy(() => import('../pages/desktop/NotFound'));
const InboxComponent = lazy(() => import('../pages/desktop/Inbox'));
const FavoritesList = lazy(() => import('../pages/desktop/FavoritesList'));
const VisitsComponent = lazy(() => import('../pages/desktop/Visits'));
const ProfileEditComponent = lazy(() => import('../pages/desktop/ProfileEdit'));
const ExploreComponent = lazy(() => import('../pages/desktop/Explore'));
const SettingsComponent = lazy(() => import('../pages/desktop/Settings'));
const PhotoRequestsComponent = lazy(
  () => import('../pages/desktop/PhotoRequests')
);
const MySubscription = lazy(() =>
  import('../pages/desktop/MySubscription').then(module => ({
    default: module.MySubscription,
  }))
);
const Criteria = lazy(() => import('../pages/desktop/Criteria'));
const RedirectToSpecialOfferFromCRM = lazy(
  () => import('../pages/desktop/RedirectToSpecialOfferFromCrm')
);
const RedirectToPaymentFromCRM = lazy(
  () => import('../pages/desktop/RedirectToPaymentFromCrm')
);
const ProfileCaptureQuestion = lazy(
  () => import('../pages/desktop/ProfileCaptureQuestion')
);
const ProfileCaptureSafetyTips = lazy(
  () => import('../pages/desktop/ProfileCaptureSafetyTips')
);
const ProfileCaptureWhyPremium = lazy(
  () => import('../pages/desktop/ProfileCaptureWhyPremium')
);
const ProfileCaptureUploadPhoto = lazy(
  () => import('../pages/desktop/ProfileCaptureUploadPhoto')
);
const ProfileCaptureAnnounce = lazy(
  () => import('../pages/desktop/ProfileCaptureAnnounce')
);
const PrrofileCaptureCrossSellLegalCheck = lazy(
  () => import('../pages/desktop/ProfileCaptureXSellLegal')
);
// inject imports before this
const RedirectToVisitsOrProfileDisplayFromCRM = lazy(
  () => import('../pages/desktop/RedirectToVisitsOrProfileDisplayFromCrm')
);

const RedirectToFavoritesOrProfileDisplayFromCRM = lazy(
  () => import('../pages/desktop/RedirectToFavoritesOrProfileDisplayFromCrm')
);

// inject imports before this

const pages = [
  {
    path: RoutesNames.Login,
    Component: HomeComponent,
    params: { exact: true },
  },
  { path: RoutesNames.Home, Component: HomeComponent },
  { path: RoutesNames.ProfileDisplay, Component: ProfileDisplayComponent },
  { path: RoutesNames.Inbox, Component: InboxComponent },
  { path: RoutesNames.Favorite, Component: FavoritesList },
  { path: RoutesNames.Visits, Component: VisitsComponent },
  { path: RoutesNames.PhotoRequests, Component: PhotoRequestsComponent },
  { path: RoutesNames.MyProfile, Component: ProfileEditComponent },
  { path: RoutesNames.Explore, Component: ExploreComponent },
  {
    path: RoutesNames.Settings,
    Component: SettingsComponent,
  },
  { path: RoutesNames.MySubscription, Component: MySubscription },
  { path: RoutesNames.Criteria, Component: Criteria },
  {
    path: RoutesNames.RedirectToSpecialOfferFromCRM,
    Component: RedirectToSpecialOfferFromCRM,
  },
  {
    path: RoutesNames.RedirectToPaymentFromCRM,
    Component: RedirectToPaymentFromCRM,
  },
  {
    path: `${RoutesNames.ProfileCapturePrefix}/:chapterLabel(search|vision|personality|tastes|values|personal-data)/:questionIndex`,
    Component: ProfileCaptureQuestion,
  },
  {
    path: RoutesNames.ProfileCaptureSafetyTips,
    Component: ProfileCaptureSafetyTips,
  },
  {
    path: RoutesNames.WhyPremium,
    Component: ProfileCaptureWhyPremium,
  },
  {
    path: RoutesNames.ProfileCaptureProfilePicture,
    Component: ProfileCaptureUploadPhoto,
  },
  {
    path: RoutesNames.ProfileCaptureAnnounce,
    Component: ProfileCaptureAnnounce,
  },
  {
    path: RoutesNames.ProfileCaptureCrossSellLegalCheck,
    Component: PrrofileCaptureCrossSellLegalCheck,
  },
  {
    path: RoutesNames.RedirectToVisitsOrProfileDisplayFromCRM,
    Component: RedirectToVisitsOrProfileDisplayFromCRM,
  },
  {
    path: RoutesNames.RedirectToFavoritesOrProfileDisplayFromCRM,
    Component: RedirectToFavoritesOrProfileDisplayFromCRM,
  },
  // inject routes before this
  { path: '*', Component: NotFoundComponent },
];

if (process.env.NODE_ENV === 'development') {
  pages.splice(pages.length - 1, 0, {
    path: RoutesNames.LoginDebug,
    Component: LoginDebugComponent,
  });
}

export default pages;
